import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ToastService } from '@shared/services/toast.service';
import { FileUtils } from '@shared/utils/file.utils';
import { StringUtils } from '@shared/utils/string.utils';

@Component({
  selector: 'app-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent {

  // Lógica interna
  fileToUpload: File = null;
  hasFileName = false;

  public fileIcon = 'fa-file';

  // Tipos de arquivos válidos (caso não seja informado, aceitará todos os tipos)
  @Input() allowedTypes: string[];

  // Evento disparado quando um arquivo é selecionado
  @Output() fileChange: EventEmitter<File> = new EventEmitter();

  // Referência de origem do arquivo
  @ViewChild('fileInput') inputRef: ElementRef<HTMLInputElement>;

  constructor(private toast: ToastService) {}

  handleFileInput(files: FileList) {
    let fileToUpload = files?.item(0);
    if (!fileToUpload) {
      return;
    }
    fileToUpload = FileUtils.rename(fileToUpload, StringUtils.normalize(fileToUpload.name));
    const ok = this.allowedTypes ? this.allowedTypes.includes('.' + this.getFileExtension(fileToUpload)) : true;
    if (ok) {
      this.fileToUpload = fileToUpload;
      this.setIcon();
      this.upload();
    } else {
      this.toast.show(`${fileToUpload.name} não é um arquivo válido`, 'danger');
    }
    if (this.inputRef?.nativeElement) {
      this.inputRef.nativeElement.value = null;
    }
  }

  upload() {
    this.hasFileName = true;
    this.fileChange.emit(this.fileToUpload);
  }

  trigger() {
    this.inputRef.nativeElement.click();
  }

  getFileName() {
    if (this.fileToUpload) {
      const name = this.fileToUpload.name.split('.');
      name.pop();
      return name.join('.');
    }
  }

  getFileExtension(file: File) {
    if (file) {
      const props = file.name.split('.');
      return props[props.length - 1];
    }
  }

  private setIcon() {
    switch (this.getFileExtension(this.fileToUpload)) {
      case 'rar':
      case 'zip':  this.fileIcon = 'fa-file-archive';
                   break;
      case 'txt':
      case 'odf':  this.fileIcon = 'fa-file-alt';
                   break;
      case 'xls':
      case 'xlsx': this.fileIcon = 'fa-file-excel';
                   break;
      case 'doc':
      case 'docx': this.fileIcon = 'fa-file-word';
                   break;
      case 'csv':  this.fileIcon = 'fa-file-csv';
                   break;
      default:     this.fileIcon = 'fa-file'
    }
  }

  public clear() {  
    this.fileToUpload = null;
    this.hasFileName = false;
    this.fileIcon = 'fa-file';
    if (this.inputRef?.nativeElement) {
      this.inputRef.nativeElement.value = null;
    }
  }

}
